export const EASE_OUT = [0.23, 1, 0.32, 1];
export const EASE_IN_OUT = [0.77, 0, 0.175, 1];

export const DURATION = {
  fast: 0.18,
  normal: 0.24,
  slow: 0.26,
};

export const SPRING_PILL = {
  type: 'spring',
  stiffness: 420,
  damping: 34,
  mass: 0.55,
};

export const pageVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.06, delayChildren: 0.04 },
  },
};

export const fadeUpVariants = {
  hidden: { opacity: 0, y: 8, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: DURATION.normal, ease: EASE_OUT },
  },
};

export const staggerGridVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.12,
    },
  },
};

export const cardVariants = {
  hidden: { opacity: 0, y: 16, scale: 0.96 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.42, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    y: -6,
    scale: 0.98,
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  },
};

export const alertVariants = {
  hidden: { opacity: 0, height: 0, marginBottom: 0 },
  visible: {
    opacity: 1,
    height: 'auto',
    marginBottom: 16,
    transition: { duration: 0.2, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    height: 0,
    marginBottom: 0,
    transition: { duration: 0.16, ease: EASE_OUT },
  },
};

export const overlayVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.16, ease: EASE_OUT },
  },
};

export const modalPanelVariants = {
  hidden: { opacity: 0, y: 10, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: DURATION.slow, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    y: 8,
    scale: 0.98,
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  },
};

export const toastVariants = {
  hidden: { opacity: 0, x: 24, scale: 0.96 },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { duration: DURATION.normal, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    x: 16,
    scale: 0.96,
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  },
};

export const swapVariants = {
  hidden: { opacity: 0, y: 10, scale: 0.985 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.22, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    y: -8,
    scale: 0.99,
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  },
};

export const pageSwapVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.2, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.14, ease: EASE_OUT },
  },
};

export const dropdownVariants = {
  hidden: { opacity: 0, y: -6, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: DURATION.fast, ease: EASE_OUT },
  },
  exit: {
    opacity: 0,
    y: -4,
    scale: 0.98,
    transition: { duration: 0.14, ease: EASE_OUT },
  },
};

export function tabSwapVariants(direction = 1) {
  const xEnter = direction >= 0 ? 14 : -14;
  const xExit = direction >= 0 ? -10 : 10;
  return {
    hidden: { opacity: 0, x: xEnter, y: 4 },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.22, ease: EASE_OUT },
    },
    exit: {
      opacity: 0,
      x: xExit,
      y: 0,
      transition: { duration: DURATION.fast, ease: EASE_OUT },
    },
  };
}

export function motionTransition(reducedMotion, duration = DURATION.normal) {
  if (reducedMotion) return { duration: 0 };
  return { duration, ease: EASE_OUT };
}

export function reducedVariants(variants, reducedMotion) {
  if (!reducedMotion) return variants;
  const zero = (state) => {
    if (!state || typeof state !== 'object') return state;
    const next = { ...state };
    if ('transition' in next) next.transition = { duration: 0 };
    return next;
  };
  return Object.fromEntries(
    Object.entries(variants).map(([key, value]) => [key, zero(value)]),
  );
}
